import { requestV2 } from 'store/common/utils';
/**
 * Get project transactions stats
 *
 * Get transaction summary statistics (count, total, average, median) for a specific project by ID
 */
export const getTransactionsStatsApi = (projectId) => requestV2({
    url: `projects/${projectId}/transactions-summary`,
    method: 'GET',
});
/**
 * Get summary transactions
 *
 * Get summary of DLD transactions (statistics + chart + list of transactions) for a specific project with optional filters
 */
export const getTransactionsSummaryApi = (projectId, params) => requestV2({
    url: `projects/${projectId}/transactions-aggregate`,
    method: 'GET',
    params,
});
/**
 * List transactions by project
 *
 * Get list of DLD transactions for a specific project
 */
export const getTransactionsApi = (projectId, params) => requestV2({
    url: `projects/${projectId}/transactions`,
    method: 'GET',
    params,
});
